import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
    createKpi,
    fetchKpiSetById,
    fetchBcsList,
    getaudit_frequency,
    getimprovement_basis,
    getAllTemplates,
} from "../../actions/kpiActions";

import {
    Card,
    CardContent,
    CardHeader,
    TextField,
    Select,
    MenuItem,
    Button,
    Tooltip,
    InputLabel,
    FormControl,
    Checkbox,
    ListItemText,
} from "@material-ui/core";

import SaveIcon from "@material-ui/icons/Save";
import AddIcon from "@material-ui/icons/Add";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { fetchTeamUser } from '../../actions/teamActions';
import LocalAgentDrawer from '../AgenticSupport/LocalAgentDrawer';
import AiInlineSetupPanel from '../AgenticSupport/AiInlineSetupPanel';
import PremiumAgenticButton from '../AgenticSupport/PremiumAgenticButton';
import { KPI_SCENARIOS, KPI_SETUP_SCENARIOS, MODULE_KPI_SETUP } from '../AgenticSupport/localAgentConstants';
import CacheStorage from "../../utils/CacheStorage";
import api from "../DataManagement/Api";

const SHOW_SUBKPIS = false;

const KpiCreateModified = ({ createNewKpi, setId }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { KpiId } = useParams();

    // Helper to parse company/industry/project initially from sessionStorage/CacheStorage
    const getInitialContext = () => {
        let pId = setId || "";
        let compObj = null;
        let projObj = null;

        try {
            const projectSelectionStr = sessionStorage.getItem("projectSelection");
            if (projectSelectionStr) {
                const projectSelection = JSON.parse(projectSelectionStr);
                if (projectSelection) {
                    if (!pId) {
                        pId = projectSelection.capProjectID || projectSelection.capProject?.DecompositionProjectID || projectSelection.ampProject?.BMProjectID || "";
                    }
                    compObj = projectSelection.client || null;
                    projObj = projectSelection.capProject || projectSelection.ampProject || null;
                }
            }
        } catch (e) {
            console.error("Error parsing projectSelection initially:", e);
        }

        if (!pId) {
            pId = CacheStorage.getItem("DecompositionProjectID") || CacheStorage.getItem("benchmark_project_id") || "";
        }

        return { pId, compObj, projObj };
    };

    const initialCtx = getInitialContext();
    const [projectId, setProjectId] = useState(initialCtx.pId);
    const [companyDetails, setCompanyDetails] = useState(initialCtx.compObj);
    const [projectDetails, setProjectDetails] = useState(initialCtx.projObj);

    useEffect(() => {
        const fetchCompanyDetails = async () => {
            const userEmail = sessionStorage.getItem("userEmail") || localStorage.getItem("userEmail") || "";
            const userId = localStorage.getItem("UserId") || "";
            if (!userId) return;

            try {
                const res = await api.get("/getAllCompanies", {
                    headers: {
                        "x-tenant-schema": "Amplo111",
                        "x-user-id": userId,
                        "x-user-email": userEmail
                    }
                });
                const companies = res.data?.data || [];
                if (companies.length > 0) {
                    let matchedCompany = companies[0];
                    try {
                        const projectSelectionStr = sessionStorage.getItem("projectSelection");
                        if (projectSelectionStr) {
                            const projectSelection = JSON.parse(projectSelectionStr);
                            const contextCompanyId = String(projectSelection.clientID || projectSelection.client?.company_id || projectSelection.ampProject?.CompanyID || "");
                            if (contextCompanyId) {
                                const found = companies.find(c => String(c.company_id) === contextCompanyId);
                                if (found) matchedCompany = found;
                            }
                        }
                    } catch (e) {
                        console.error("Error matching company in KPI useEffect:", e);
                    }

                    if (!companyDetails) {
                        setCompanyDetails(matchedCompany);
                    }
                }
            } catch (err) {
                console.error("Failed to fetch companies for KPI setup context:", err);
            }
        };

        if (!companyDetails) {
            fetchCompanyDetails();
        }
    }, [companyDetails, setId]);

    const bscList = useSelector((state) => state.kpiData.kpiBsc || []);
    const personas = useSelector((state) => state.teamData.teamData || []);
    const auditFrequency = useSelector((state) => state.kpiData.frequency || []);
    const templates = useSelector((state) => state.kpiData.templates || []);

    let kpiSetData = useSelector((state) => state.kpiData.kpiSetDetails || []);
    const kpiDetails =
        Array.isArray(kpiSetData) && kpiSetData.length > 0 ? kpiSetData[0] : null;

    // Local state
    const [kpiTitle, setKpiTitle] = useState("");
    const [businessMetrics, setBusinessMetrics] = useState("");
    const [description, setDescription] = useState("");
    const [bscCategory, setBscCategory] = useState("");
    const [templateId, setTemplateId] = useState("");

    const [baselineValue, setBaselineValue] = useState("");
    const [baselineUnit, setBaselineUnit] = useState("");
    const [baselineUnityType, setBaselineUnitType] = useState("");
    const [baselineYear, setBaselineYear] = useState("");
    const [polarity, setPolarity] = useState("");

    const [targetGrowth, setTargetGrowth] = useState("");
    const [unitOfTargetGrowth, setUnitOfTargetGrowth] = useState("");
    const [unitTypeOfTargetGrowth, setUnitTypeOfTargetGrowth] = useState("");
    const [auditFrequencyVal, setAuditFrequencyVal] = useState("");
    const [startDate, setStartDate] = useState("");
    const [targetDate, setTargetDate] = useState("");

    const [selectedPersonas, setSelectedPersonas] = useState([]);
    const [stakeholders, setStakeholders] = useState("");
    const [stakeholderTitle, setStakeholderTitle] = useState("");


    const [subKpis, setSubKpis] = useState([]);

    // AI Advisory Drawer State
    const [isLocalAgentOpen, setLocalAgentOpen] = useState(false);
    const [isKpiSetupAssistOpen, setKpiSetupAssistOpen] = useState(false); // Closed by default as per user request

    // Initial fetch
    useEffect(() => {
        dispatch(fetchBcsList());
        dispatch(fetchTeamUser());
        dispatch(getaudit_frequency());
        dispatch(getimprovement_basis());
        dispatch(getAllTemplates());

        if (createNewKpi) {
            kpiSetData = []
            setKpiTitle("");
            setBusinessMetrics("");
            setDescription("");
            setBscCategory("");
            setTemplateId("");
            setBaselineValue("");
            setBaselineUnitType("");
            setBaselineUnit("");
            setBaselineYear("");
            setPolarity("");
            setTargetGrowth("");
            setUnitOfTargetGrowth("");
            setAuditFrequencyVal("");
            setStartDate("");
            setTargetDate("");
            setSelectedPersonas([]);
            setSubKpis([]);
        } else if (KpiId) {
            dispatch(fetchKpiSetById(KpiId));
        }
    }, [dispatch, createNewKpi, KpiId]);

    const formatDateForInput = (dateStr) => {
        if (!dateStr) return "";

        // Normalize AM/PM format first
        const normalized = dateStr.replace(":AM", " AM").replace(":PM", " PM");
        const d = new Date(normalized);

        if (isNaN(d)) return "";

        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    };


    // Prefill form if editing
    useEffect(() => {
        if (kpiSetData?.length > 0) {
            setKpiTitle(kpiDetails.KPITitle || "");
            setBusinessMetrics(kpiDetails.BusinessMetrics || "");
            setDescription(kpiDetails.Purpose || kpiDetails.Description || "");
            setBscCategory(kpiDetails.CategoryLookUpId || "");
            setTemplateId(kpiDetails.TemplateID || "");

            setBaselineValue(kpiDetails.BaselineValue || "");
            setBaselineUnit(kpiDetails.BaselineUnit || "");
            setBaselineUnitType(kpiDetails.BaselineUnitType || "");
            setBaselineYear(kpiDetails.BaselineYear || "");
            setPolarity(kpiDetails.Polarity || "");

            setTargetGrowth(kpiDetails.ExpectedTargetGrowthAmount || "");
            setUnitOfTargetGrowth(kpiDetails.UnitOfMeasurement || "");
            setUnitTypeOfTargetGrowth(kpiDetails.UnitTypeOfMeasurement || "");
            setAuditFrequencyVal(kpiDetails.AuditFrequency || "");
            setStartDate(formatDateForInput(kpiDetails.KPIInitiationDate) || "");
            setTargetDate(formatDateForInput(kpiDetails.BusinessOutComeTargetDate) || "");
            setStakeholders(kpiDetails.Stakeholders || "")
            setStakeholderTitle(kpiDetails.StakeholderTitle || "")

            setSelectedPersonas(
                kpiDetails.PersonaImpacted ? kpiDetails.PersonaImpacted.split(",") : []
            );

            // load subKpis if API sends them
            setSubKpis(kpiDetails.SubKpis || []);
        }
    }, [kpiSetData]);

    const buildPayload = (extraFields = {}) => ({
        KPIID: KpiId || 0,
        KPIName: kpiTitle,
        KPITitle: kpiTitle,
        Purpose: description,
        Metrics: businessMetrics,
        Description: description,

        CategoryLookUpId: bscCategory ? Number(bscCategory) : null,
        TemplateID: templateId ? Number(templateId) : null,

        BaselineValue: baselineValue === "" ? null : Number(baselineValue),
        BaselineUnit: baselineUnit || null,
        BaselineUnitType: baselineUnityType === "" ? null : (baselineUnityType),
        BaselineYear: baselineYear === "" ? null : Number(baselineYear),


        ExpectedTargetGrowthAmount: targetGrowth === "" ? null : Number(targetGrowth),
        UnitOfMeasurement: unitOfTargetGrowth || null,
        UnitTypeOfMeasurement: unitTypeOfTargetGrowth || null,

        Polarity: polarity || null,
        AuditFrequency: auditFrequencyVal || null,
        KpiInitiationDate: startDate || null,
        BusinessOutComeTargetDate: targetDate || null,

        Stakeholders: stakeholders || null,
        StakeholderTitle: stakeholderTitle || null,
        PersonaImpacted: selectedPersonas.join(","),

        KpiSetId: Number(0),
        SubKpis: subKpis, // still included in payload

        ...extraFields,
    });

    const validateKpi = (kpi) => {
        if (!kpi.KPITitle?.trim()) return "KPI Name is required";
        if (!kpi.Metrics?.trim()) return "Metrics is required";
        if (!kpi.Description?.trim()) return "Purpose is required";
        if (!kpi.TemplateID) return "Data Template is required";
        if (!kpi.BaselineValue) return "Baseline Value is required";
        if (!kpi.BaselineUnitType) return "Baseline unit type is required";
        if (!kpi.BaselineYear?.toString().trim()) return "Year is required";
        if (!kpi.PersonaImpacted || kpi.PersonaImpacted.length === 0)
            return "Persona Impacted is required";
        return null;
    };

    const handleSave = () => {
        const parentError = validateKpi(buildPayload());
        if (parentError) {
            alert(parentError);
            return;
        }

        // keep sub-KPI validation in place, even if UI is hidden
        for (let sub of subKpis) {
            const subError = validateKpi(sub);
            if (subError) {
                alert(`Sub-KPI error: ${subError}`);
                return;
            }
        }

        dispatch(createKpi(buildPayload()));
        history.push("/kpi-setting");
    };

    const getFinancialYears = (count = 5) => {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let i = 0; i < count; i++) {
            const start = currentYear - i;
            const end = start + 1;
            years.push({ label: `FY ${start}-${end}`, value: start }); // store start year only
        }
        return years;
    };

    const financialYears = getFinancialYears(5);


    return (
        <div className="container-fluid kpi-create">
            {/* Toolbar */}
            <div className="d-flex justify-content-between align-items-center mb-4">
                <div className="d-flex align-items-center">
                    <h4 className="mb-0 mr-3">{KpiId ? "Edit KPI" : "Create KPI"}</h4>
                    {/* AgenticFloatingButton added at root instead of inline */}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <PremiumAgenticButton
                        label="KPI Setup Assist"
                        onClick={() => setKpiSetupAssistOpen(!isKpiSetupAssistOpen)}
                        style={{ height: '36px' }}
                    />
                    <Tooltip title="Back">
                        <Button
                            variant="outlined"
                            color="default"
                            onClick={() => history.push("/kpi-setting")}
                            style={{ height: '36px' }}
                        >
                            <ArrowBackIcon style={{ marginRight: 5 }} /> Back
                        </Button>
                    </Tooltip>
                    <Tooltip title="Save">
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSave}
                            style={{ height: '36px' }}
                        >
                            <SaveIcon style={{ marginRight: 5 }} /> Save
                        </Button>
                    </Tooltip>
                </div>
            </div>

            {/* KPI Setup Assist Inline Panel */}
            <AiInlineSetupPanel
                isOpen={isKpiSetupAssistOpen}
                onClose={() => setKpiSetupAssistOpen(false)}
                moduleKey={MODULE_KPI_SETUP}
                scenarios={KPI_SETUP_SCENARIOS}
                contextData={{
                    kpiTitle: kpiTitle,
                    businessMetrics: businessMetrics,
                    unitType: baselineUnityType,
                    company: companyDetails,
                }}
            />

            {/* General Info */}
            <Card className="mb-4">
                <CardHeader title="General Information" />
                <CardContent>
                    <div className="row">
                        <div className="col-md-6">
                            <TextField
                                label="KPI Name *"
                                fullWidth
                                value={kpiTitle}
                                onChange={(e) => setKpiTitle(e.target.value)}
                            />
                        </div>
                        <div className="col-md-6">
                            <TextField
                                label="Business Metrics *"
                                fullWidth
                                value={businessMetrics}
                                onChange={(e) => setBusinessMetrics(e.target.value)}
                            />
                        </div>
                        <div className="col-md-12 mt-3">
                            <TextField
                                label="Description *"
                                fullWidth
                                multiline
                                minRows={3}
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                            />
                        </div>
                        <div className="col-md-6 mt-3">
                            <FormControl fullWidth>
                                <InputLabel>BSC Category</InputLabel>
                                <Select
                                    value={bscCategory}
                                    onChange={(e) => setBscCategory(e.target.value)}
                                >
                                    {bscList.map((cat) => (
                                        <MenuItem key={cat.CategoryLookUpId} value={cat.CategoryLookUpId}>
                                            {cat.CategoryName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                        <div className="col-md-6 mt-3">
                            <FormControl fullWidth>
                                <InputLabel>Data Template *</InputLabel>
                                <Select
                                    value={templateId}
                                    onChange={(e) => setTemplateId(e.target.value)}
                                >
                                    {templates.map((tpl) => (
                                        <MenuItem key={tpl.template_id} value={tpl.template_id}>
                                            {tpl.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                </CardContent>
            </Card>

            {/* Baseline */}
            <Card className="mb-4">
                <CardHeader title="Baseline" />
                <CardContent>
                    <div className="row">
                        <div className="col-md-3">
                            <TextField
                                label="Baseline Value *"
                                fullWidth
                                value={baselineValue}
                                onChange={(e) => setBaselineValue(e.target.value)}
                            />
                        </div>

                        <div className="col-md-3">
                            <FormControl fullWidth>
                                <InputLabel>Unit Type *</InputLabel>
                                <Select
                                    value={baselineUnityType}
                                    onChange={(e) => setBaselineUnitType(e.target.value)}
                                >
                                    <MenuItem value="number">Number</MenuItem>
                                    <MenuItem value="percentage">Percentage</MenuItem>
                                    <MenuItem value="amount">Amount</MenuItem>
                                    <MenuItem value="currency">Currency</MenuItem>
                                </Select>
                            </FormControl>
                        </div>

                        {(baselineUnityType !== "number" && baselineUnityType !== "percentage") && (
                            <div className="col-md-3">
                                <TextField
                                    label="Unit *"
                                    fullWidth
                                    value={baselineUnit}
                                    onChange={(e) => setBaselineUnit(e.target.value)}
                                />
                            </div>
                        )}

                        <div className="col-md-2">
                            <FormControl fullWidth>
                                <InputLabel>Year *</InputLabel>
                                <Select
                                    value={baselineYear}
                                    onChange={(e) => setBaselineYear(e.target.value)}
                                >
                                    {financialYears.map((fy) => (
                                        <MenuItem key={fy.value} value={fy.value}>
                                            {fy.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>

                    </div>
                </CardContent>
            </Card>

            {/* Target */}
            <Card className="mb-4">
                <CardHeader title="Target" />
                <CardContent>
                    <div className="row">
                        <div className="col-md-3">
                            <TextField
                                label="Target Growth/Reduction"
                                fullWidth
                                value={targetGrowth}
                                onChange={(e) => setTargetGrowth(e.target.value)}
                            />
                        </div>
                        <div className="col-md-3">
                            <FormControl fullWidth>
                                <InputLabel>Unit Type of Measurement</InputLabel>
                                <Select
                                    value={unitTypeOfTargetGrowth}
                                    onChange={(e) => setUnitTypeOfTargetGrowth(e.target.value)}
                                >
                                    <MenuItem value="number">Number</MenuItem>
                                    <MenuItem value="percentage">Percentage</MenuItem>
                                    <MenuItem value="amount">Amount</MenuItem>
                                    <MenuItem value="currency">Currency</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        <div className="col-md-3">
                            {(unitTypeOfTargetGrowth !== "number" && unitTypeOfTargetGrowth !== "percentage") && (
                                <TextField
                                    label="Unit of Measurement *"
                                    fullWidth
                                    value={unitOfTargetGrowth}
                                    onChange={(e) => setUnitOfTargetGrowth(e.target.value)}
                                />
                            )}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-2 mt-3">
                            <FormControl fullWidth>
                                <InputLabel>Audit Frequency</InputLabel>
                                <Select
                                    value={auditFrequencyVal}
                                    onChange={(e) => setAuditFrequencyVal(e.target.value)}
                                >
                                    {auditFrequency.map((opt, idx) => (
                                        <MenuItem key={idx} value={opt}>
                                            {opt}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                        <div className="col-md-4 mt-3">
                            <TextField
                                type="date"
                                label="Start Date"
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                            />
                        </div>
                        <div className="col-md-4 mt-3">
                            <TextField
                                type="date"
                                label="Target Date"
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                value={targetDate}
                                onChange={(e) => setTargetDate(e.target.value)}
                            />
                        </div>
                        <div className="col-md-2 mt-3">
                            <FormControl fullWidth>
                                <InputLabel>Polarity</InputLabel>
                                <Select
                                    value={polarity}
                                    onChange={(e) => setPolarity(e.target.value)}
                                >
                                    <MenuItem value="+">+</MenuItem>
                                    <MenuItem value="-">-</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                </CardContent>
            </Card>

            {/* Stakeholders */}
            <Card className="mb-4">
                <CardHeader title="Stakeholders" />
                <CardContent>
                    <div className="row">
                        <div className="col-md-3">
                            <TextField
                                label="Stackeholders"
                                fullWidth
                                value={stakeholders}
                                onChange={(e) => setStakeholders(e.target.value)}
                            />
                        </div>
                        <div className="col-md-3">
                            <TextField
                                label="Tiltle of Stakeholder"
                                fullWidth
                                value={stakeholderTitle}
                                onChange={(e) => setStakeholderTitle(e.target.value)}
                            />
                        </div>
                        <div className="col-md-3">
                            <FormControl fullWidth>
                                <InputLabel>Personas *</InputLabel>
                                <Select
                                    multiple
                                    value={selectedPersonas}
                                    onChange={(e) => setSelectedPersonas(e.target.value)}
                                    renderValue={(selected) => selected.join(", ")}
                                >
                                    {personas.map((p) => (
                                        <MenuItem key={p.PersonaId} value={p.Email}>
                                            <Checkbox
                                                checked={selectedPersonas.indexOf(p.Email) > -1}
                                            />
                                            <ListItemText primary={p.Email} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                </CardContent>
            </Card>

            {SHOW_SUBKPIS && (
                <Card className="mb-4">
                    <CardHeader
                        title="Sub-KPIs"
                        action={
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() =>
                                    setSubKpis([
                                        ...subKpis,
                                        {
                                            id: Date.now(),
                                            KPITitle: "",
                                            BusinessMetrics: "",
                                            Description: "",
                                            TemplateID: "",
                                            BaselineValue: "",
                                            BaselineUnitType: "",
                                            BaselineUnit: "",
                                            BaselineYear: "",
                                            PersonaImpacted: "",
                                            ExpectedTargetGrowthAmount: "",
                                            UnitOfMeasurement: "",
                                        },
                                    ])
                                }
                            >
                                <AddIcon style={{ marginRight: 5 }} /> Add Sub-KPI
                            </Button>
                        }
                    />
                    <CardContent>
                        {/* Sub-KPI UI here */}
                    </CardContent>
                </Card>
            )}

            <LocalAgentDrawer
                isOpen={isLocalAgentOpen}
                onClose={() => setLocalAgentOpen(false)}
                moduleKey="kpi"
                scenarios={KPI_SCENARIOS}
                title={`Analyze KPI: ${kpiTitle || 'Performance Index'}`}
                projectName={kpiTitle || 'KPI'}
                contextData={{
                    kpiTitle: kpiTitle,
                    metric: businessMetrics,
                    baseline: baselineValue,
                    target: targetGrowth,
                    targetDate: targetDate,
                    estimatedSavings: "",
                    controlLevers: [],
                    stakeholders: stakeholders,
                    company: companyDetails,
                }}
            />
        </div>
    );
};

export default KpiCreateModified;
